module.exports = __webpack_public_path__ + "img/profil_icon.d0c24da8.svg";